"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = CollaborationProvider;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireDefault(require("react")),
    _reactApollo = require("react-apollo"),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _CollaborationProvider = _interopRequireDefault(require("../components/CollaborationProvider")),
    _api = require("../api");

function CollaborationProvider(props) {
  return _react["default"].createElement(_reactApollo.ApolloConsumer, null, function (apiClient) {
    return _react["default"].createElement(_RequestProvider["default"], {
      requests: {
        getUsersByName: (0, _api.getUsersByName)(),
        getTeamsByName: (0, _api.getTeamsByName)(),
        upsertRoleAssignments: (0, _api.upsertRoleAssignments)(),
        getResourceRoles: (0, _api.getResourceRoles)(),
        deleteRoleAssignments: (0, _api.deleteRoleAssignments)(),
        getRoleAssignments: (0, _api.getRoleAssignments)()
      }
    }, function (requests) {
      return _react["default"].createElement(_CollaborationProvider["default"], (0, _extends2["default"])({}, props, requests, {
        apiClient: apiClient
      }));
    });
  });
}